module.exports = __webpack_public_path__ + "static/media/icon-header-products.178d1797.svg";